<template>
  <div>
    <h2 class="tw-text-xl tw-font-bold tw-text-center tw-mb-5">
      Zoom Meeting Recordings
    </h2>

    <div>
      <table>
        <thead>
          <tr>
            <th />
            <th>Topic</th>
            <th>Start Time</th>
            <th>Duration (min)</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="meeting in meetings"
            :key="meeting.id"
          >
            <td @click="uploadMeeting(meeting)">
              <i
                :class="[
                  'fas',
                  uploadingMeetings.has(meeting.id) ? 'fa-spinner fa-spin' : 'fa-upload tw-cursor-pointer',
                ]"
              />
            </td>
            <td>{{ meeting.topic }}</td>
            <td>{{ meeting.start_time }}</td>
            <td>{{ meeting.duration }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'ZoomMeetingList',
  components: { /* Subcomponents */ },
  props: [/* Inputs */],
  data() {
    return {
      meetings: [],
      entityExternalId: null,
      uploadInProgress: null,
      uploadingMeetings: new Set(),
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    headers() {
      return {
        'X-CSRFToken': this.$root.$data.csrfToken,
        'Content-Type': 'application/json',
      };
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {
    this.entityExternalId = this.$route.params.entityExternalId;
    this.getRecordings();
  },
  mounted() {},
  updated() {},
  methods: {
    async getRecordings() {
      const res = await fetch('/api/v1/zoom/recordings/', {
        method: 'GET',
        headers: this.headers,
      });
      const data = await res.json();
      this.meetings = data.meetings;
    },
    async uploadMeeting(meeting) {
      if (this.uploadingMeetings.has(meeting.id)) return;
      
      try {
        this.uploadingMeetings.add(meeting.id);
        const recording = meeting.recording_files.find(
          file => file.recording_type === 'audio_only',
        );

        if (!recording) {
          throw new Error('No audio recording found');
        }

        const res = await fetch('/api/v1/zoom/upload/', {
          method: 'POST',
          headers: this.headers,
          body: JSON.stringify({
            entity_external_id: this.entityExternalId,
            recording_url: recording.download_url,
            meeting: meeting,
          }),
        });

        const data = await res.json();
        if (!res.ok) {
          throw new Error(data.message || 'Upload failed');
        }

        this.$emit('uploaded', data);
      } catch (error) {
        console.error('Upload failed:', error);
        // Optionally emit error event
        this.$emit('upload-error', { meeting, error });
      } finally {
        this.uploadingMeetings.delete(meeting.id);
      }
    },
  },
};
</script>


<style scoped>
  th, td {
    padding: 0.5em;
  }
</style>
